export {
    tryCheckRecipientPermissionForOneLink,
} from './utils/tryCheckRecipientPermissionForOneLink';
export { tryCheckRecipientPermissionForLinks } from './utils/tryCheckRecipientPermissionForLinks';
